// TTL PRICE 830


export const descriptions: any = {
    'CDJ-3000': {
        pl: [
            "Odtwarzane media: karty pamięci SD, pamięci i dyski USB, PC/Mac, iPhone",
            "Odtwarzane pliki: WAV, AIFF, FLAC, Apple Lossless (Sampling: 44.1/48/88.2/96 kHz, 16/24 bit), MP3 (Sampling: 44.1/48 kHz, Bit: 16 bit), AAC (Sampling: 44.1/48 kHz, Bit: 16 bit)",
            "USB: obsługiwane formaty plików FAT16, FAT32, HFS+",
            "Oprogramowanie: Rekordbox",
            "Pasmo przenoszenia: 4 Hz do 40 kHz",
            "Sygnał/szum: 115 dB lub więcej",
            "Całkowite zniekształcenia harmoniczne: 0.0018 % lub mniej",
            "Wyjście audio: 2.0 Vrms",
            "Gniazda wyjściowe: Analogowe (RCA), Cyfrowe (koaksjalne)",
            "Porty USB: USB (Typ A), USB (Typ B)",
            "Inne gniazda: LAN (1000Base-T)",
            "Zasilanie: AC 100-240 V 50/60 Hz",
            "Pobór mocy: 40 W",
            "Wymiary [mm]: 329 x 453 x 118",
            "Waga: 5.5 kg"
        ],
        en: [
            "Playable media: SD cards, memory and USB drives, PC/Mac, iPhone",
            "Supported file formats: WAV, AIFF, FLAC, Apple Lossless (Sampling: 44.1/48/88.2/96 kHz, 16/24 bit), MP3 (Sampling: 44.1/48 kHz, Bit: 16 bit), AAC (Sampling: 44.1/48 kHz, Bit: 16 bit)",
            "USB: Supported file formats FAT16, FAT32, HFS+",
            "Software: Rekordbox",
            "Frequency range: 4 Hz to 40 kHz",
            "Signal-to-noise ratio: 115 dB or more",
            "Total harmonic distortion: 0.0018% or less",
            "Audio output: 2.0 Vrms",
            "Output sockets: Analog (RCA), Digital (coaxial)",
            "USB ports: USB (Type A), USB (Type B)",
            "Other sockets: LAN (1000Base-T)",
            "Power supply: AC 100-240 V 50/60 Hz",
            "Power consumption: 40 W",
            "Dimensions [mm]: 329 x 453 x 118",
            "Weight: 5.5 kg"
        ],
    },
    'DJM-A9': {
        pl: [
            "Liczba kanałów: 4",
            "32-bitowy przetwornik A/D o wysokiej jakości",
            "Podwójny interfejs audio umożliwiający zestawy 'back 2 back'",
            "Kompatybilne oprogramowanie: rekordbox, Serato DJ Pro, ShowKontrol, Pro DJ Link Bridge",
            "Dwa niezależne wyjścia słuchawkowe",
            "2-pasmowy EQ dla wyjścia z kabiny",
            "Rozbudowana sekcja Beat FX z 14 efektami",
            "Sound Color FX z blokadą Center",
            "Integracja urządzenia Bluetooth™",
            "Wymiary (Szer. x Gł. x Wys.): 407,4 x 458,3 x 107,9 mm (z anteną bezprzewodową 140,7 mm)",
            "Waga: 10,2 kg",
            "Kolor: Czarny"
        ],
        en: [
            "Number of channels: 4",
            "High-quality 32-bit A/D converter",
            "Dual audio interface for 'back 2 back' setups",
            "Compatible software: rekordbox, Serato DJ Pro, ShowKontrol, Pro DJ Link Bridge",
            "Two independent headphone outputs",
            "2-band EQ for booth output",
            "Expanded Beat FX section with 14 effects",
            "Sound Color FX with Center Cancel",
            "Bluetooth™ device integration",
            "Dimensions (W x D x H): 407.4 x 458.3 x 107.9 mm (with wireless antenna 140.7 mm)",
            "Weight: 10.2 kg",
            "Color: Black"
        ],
    },
    'SM58': {
        pl: [
            "Charakterystyka częstotliwościowa dobrana pod kątem wokalu, z rozjaśnionym środkowym pasmem oraz podciętymi basami",
            "Jednolita kardioidalna charakterystyka częstotliwościowa skutecznie izoluje główne źródło dźwięku i minimalizuje szumy otoczenia",
            "Pneumatyczny system antywstrząsowy ograniczający zakłócenia wynikające z operowania mikrofonem",
            "Wbudowana sferyczna owiewka i filtr pop o dużej efektywności",
            "Dołączony wytrzymały adapter statywu z możliwością obrotu o 180 stopni",
            "Legendarna jakość, wytrzymałość i użyteczność produktów Shure",
            "Wkładka dynamiczna o charakterystyce kardioidalnej (jednokierunkowej)",
            "Charakterystyka częstotliwościowa: 50 do 15000 Hz"
        ],
        en: [
            "Frequency response tailored for vocals, with a brightened midrange and reduced bass",
            "Uniform cardioid frequency response effectively isolates the main sound source and minimizes ambient noise",
            "Pneumatic shock-mount system reduces handling noise",
            "Built-in spherical wind and pop filter with high effectiveness",
            "Durable stand adapter with 180-degree rotation capability included",
            "Legendary Shure product quality, durability, and utility",
            "Dynamic cartridge with cardioid (unidirectional) polar pattern",
            "Frequency response: 50 to 15,000 Hz"
        ],
    },
    'Yamaha_MG12XU': {
        pl: [
            "12-kanałowa konsola mikserska",
            "Maksymalnie 6 wejść mikrofonowych / 12 liniowych (4 mono + 4 stereo)",
            "2 szyny grupowe GROUP + 1 szyna stereo bus",
            "2 AUX (w tym FX)",
            "Przedwzmacniacze mikrofonowe 'D-PRE' z odwróconymi układami Darlingtona",
            "1-pokrętłowe kompresory",
            "Efekty najwyższej klasy: SPX z 24 programami",
            "Rozdzielczość 24 bit / 192 kHz",
            "2 wejścia/2 wyjścia USB Audio",
            "Kompatybilny z iPad (2 lub nowszy) poprzez Apple iPad Camera Connection Kit / Lightning to USB Camera Adapter",
            "W zestawie dołączone oprogramowanie DAW do pobrania Cubase AI",
            "Przełącznik PAD na wejścia mono",
            "Zasilanie phantom +48V",
            "Symetryczne wyjścia XLR",
            "Wewnętrzny, uniwersalny zasilacz do stosowania na całym świecie",
            "Opcjonalny zestaw montażu w rack'u RK-MG12",
            "Metalowa obudowa",
            "Wymiary (szer. x wys. x gł.): 308 mm x 118 mm x 422 mm",
            "Waga netto: 4.2 kg"
        ],
        en: [
            "12-channel mixing console",
            "Up to 6 microphone inputs / 12 line inputs (4 mono + 4 stereo)",
            "2 group buses GROUP + 1 stereo bus",
            "2 AUX (including FX)",
            "Microphone preamps 'D-PRE' with inverted Darlington circuits",
            "1-knob compressors",
            "Top-class effects: SPX with 24 programs",
            "24-bit / 192 kHz resolution",
            "2 inputs/2 outputs USB Audio",
            "Compatible with iPad (2 or newer) via Apple iPad Camera Connection Kit / Lightning to USB Camera Adapter",
            "Includes Cubase AI DAW software for download",
            "PAD switch on mono inputs",
            "Phantom power +48V",
            "Balanced XLR outputs",
            "Internal universal power supply for worldwide use",
            "Optional rack-mount kit RK-MG12",
            "Metal housing",
            "Dimensions (width x height x depth): 308 mm x 118 mm x 422 mm",
            "Net weight: 4.2 kg"
        ],
    }
}


/**
 * Local snapshot of the catalogue, mirroring `productList` in the remote config
 * (pageContent.json on R2 — see SITE_CONFIG_URL in App.tsx). It is only rendered
 * when that request cannot be completed, so it must be re-synced whenever prices,
 * counts or products change in the bucket — otherwise a failed fetch quietly shows
 * prices that differ from production.
 */
const Product__List: any = {
    'CDJ-3000X': {
        producent: 'Alpha Theta',
        count: 4,
        category: [
            'DJ'
        ],
        type: 'Console',
        rentPrice: 200,
        image: 'https://pioneerdjstore.com/cdn/shop/files/CDJ3000xAngle.png?v=1757401746&width=1946',
        imageGallery: [],
    },
    'CDJ-3000': {
        producent: 'Pioneer',
        count: 8,
        category: [
            'DJ'
        ],
        type: 'Console',
        rentPrice: 200,
        image: 'https://techformusic.co.uk/wp-content/uploads/2020/09/CDJ-3000-top-hero.png',
        imageGallery: [
            'https://www.pioneerdj.com/-/media/pioneerdj/images/products/player/cdj-3000/black/cdj-3000-rear-hero.png',
            'https://www.pioneerdj.com/-/media/pioneerdj/images/products/player/cdj-3000/black/cdj-3000-top-hero.png?h=273&w=372&hash=BC03A6DE40449DA1EB362B8D850548C3',
            'https://www.pioneerdj.com/-/media/pioneerdj/images/products/player/cdj-3000/black/cdj-3000-frontangle-hero.png'
        ],
    },
    'TECHNICS_SL1210_M5G': {
        producent: 'TECHNICS',
        category: [
            'DJ'
        ],
        specialName: true,
        count: 2,
        type: 'Console',
        rentPrice: 200,
        image: '/technicsTop.png',
        imageGallery: [
            '/technicsTop.png',
            '/technics.png'
        ],
    },
    'TECHNICS MK2': {
        producent: 'TECHNICS',
        category: [
            'DJ'
        ],
        count: 2,
        type: 'Console',
        rentPrice: 150,
        image: '/technicsTop.png',
        imageGallery: [
            '/technicsTop.png',
            '/technics.png'
        ],
    },
    'DJM-A9': {
        producent: 'Pioneer',
        category: [
            'DJ'
        ],
        type: 'Mixer',
        count: 2,
        rentPrice: 200,
        image: 'https://www.pioneerdj.com/product-images/403/ce00a4f3-1f0f-4157-b65f-c05de5c68dc1/djm-a9_1.png',
        imageGallery: [
            'https://www.pioneerdj.com/product-images/403/ce00a4f3-1f0f-4157-b65f-c05de5c68dc1/djm-a9_1.png'
        ],
    },
    'DJM-V10 LF': {
        producent: 'Pioneer',
        category: [
            'DJ'
        ],
        type: 'Mixer',
        count: 1,
        rentPrice: 300,
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/djmv10.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/djmv10.png'
        ],
    },
    'DJM-V5': {
        producent: 'Alpha Theta',
        category: [
            'DJ'
        ],
        type: 'Mixer',
        count: 1,
        rentPrice: 180,
        image: 'https://assets.alphatheta.com/page-assets/djm-v5/assets/djmv5-product-specification-image-01.webp',
        imageGallery: [
            'https://assets.alphatheta.com/page-assets/djm-v5/assets/djmv5-product-specification-image-01.webp'
        ],
    },
    'Xone92': {
        producent: 'Allen & Heath',
        type: 'Mixer',
        category: [
            'DJ'
        ],
        count: 1,
        rentPrice: 150,
        image: '/xone92S115.png',
        imageGallery: [
            '/xone92S115.png'
        ],
    },
    'Xone96': {
        producent: 'Allen & Heath',
        type: 'Mixer',
        category: [
            'DJ'
        ],
        count: 1,
        rentPrice: 200,
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/xone96.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/xone96.png'
        ],
    },
    'Trex': {
        specialName: true,
        producent: 'T-rex',
        category: [
            'DJ'
        ],
        rentPrice: 100,
        count: 1,
        isSpecialPrice: false,
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/TREXREPLICATOR.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/TREXREPLICATOR.png'
        ],
    },
    'R909': {
        specialName: true,
        producent: 'Turnlab / Steda',
        category: [
            'DJ'
        ],
        rentPrice: 'lbl_coming_soon',
        count: 1,
        isSpecialPrice: false,
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/909fron.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/909fron.png'
        ],
    },
    'JBL_712-JBL_718': {
        rentPrice: 350,
        category: [
            'SCENE'
        ],
        specialName: true,
        count: 1,
        isSpecialPrice: true,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl%20bundle.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl%20bundle.png'
        ],
    },
    'JBL 718S': {
        rentPrice: 120,
        category: [
            'SCENE'
        ],
        specialName: false,
        count: 2,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl-eon-718s.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl-eon-718s.png'
        ],
    },
    'JBL 712': {
        rentPrice: 70,
        category: [
            'SCENE'
        ],
        specialName: false,
        count: 2,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl712.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/jbl712.png'
        ],
    },
    'ADJ tribar': {
        rentPrice: 10,
        category: [
            'SCENE'
        ],
        count: 4,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/ADJtribar.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/ADJtribar.png'
        ],
    },
    'Fun Generation PicoSpot 20 LED 1': {
        rentPrice: 10,
        category: [
            'SCENE'
        ],
        count: 2,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/picospot.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/picospot.png'
        ],
    },
    'Stairville AF-40 Mini Fog Machine': {
        rentPrice: 10,
        category: [
            'SCENE'
        ],
        count: 1,
        type: 'Setup',
        image: 'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/starvilefogmaschine.png',
        imageGallery: [
            'https://pub-5c03924c06b5439684cebaa3f4aba397.r2.dev/starvilefogmaschine.png'
        ],
    }
}

export const FALLBACK_PRODUCTS = Product__List

export const Contact__Values: any = {
    phoneNumbers: [
        '+48 509 363 473',
    ],
    emailAddress: 'studio@s115.pl',
    instagram: 'https://www.instagram.com/s115studio/',
    instagramHandle: '@s115studio',
    city: 'Wrocław'
}

export const languagesList = [
    {
        label: 'Polski',
        type: 'pl',
        img: 'https://upload.wikimedia.org/wikipedia/en/thumb/1/12/Flag_of_Poland.svg/1200px-Flag_of_Poland.svg.png'
    },
    {
        label: 'English',
        type: 'en',
        img: 'data:image/png;base64,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'
    },
]

export const Local__Data__Value = {
    isLoadingProducts: true,
    Products: {}
}